export default __webpack_public_path__ + "static/media/mfa-code-1.5e200f5b.png";